<template>
	<div class="search-input-wrapper">
		<md-field class="input-group search-input-group">
			<md-input 
					  type="search" 
					  id="search-input" 
					  name="searchtext" 
					  class="form-control search-input" 
					  v-model.lazy="query" 
					  aria-label="Search News..." 
					  v-on:keyup.enter="addApiUrls()"
					  @input="inputHandler">
			</md-input>
			<label for="search-input" class="form-control-placeholder">{{inputplaceholder}}</label>
			<span class="input-group-btn search-clear" v-if="query != '' && query != null">
				<input type="submit" value="" class="icon-close submit-input" v-on:click="clearSearch()" />
			</span>
			<span class="input-group-btn search-submit">
				<input class="icon-search submit-input" type="submit" value="search" v-on:click="addApiUrls()" />
			</span>
		</md-field>
	</div>
</template>

<script>
	export default {
		props: ['searchtext', 'inputplaceholder'],
		data: function () {
			return {
				query: ''
			}
		},
		watch: {
			searchtext(val, oldVal) {
				this.query = val;
			}
		},
		mounted() {
			this.query = this.searchText || '';
		},
		methods: {
			addApiUrls() {
				this.$emit('addsearchtext', this.query);
			},
			clearSearch() {
				this.query = '';
				this.addApiUrls();
			},
			inputHandler() {
				this.$emit('updatesearchtext', this.query);
			}
		}
	}

</script>